module.exports = __webpack_public_path__ + "media/images/competitions/key_dates-calendar_bg-ee85f8e026fba54d60930a1c88a04eba.png";